import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  // 개발 시 즉시 알아채도록 콘솔에 경고. 실제 배포에서는 .env 누락이면 즉시 드러남.
  // eslint-disable-next-line no-console
  console.warn(
    '[admin/supabase] VITE_SUPABASE_URL 또는 VITE_SUPABASE_ANON_KEY 환경변수가 없습니다. ' +
      'admin/.env 또는 Vercel 프로젝트 환경변수를 확인하세요.',
  )
}

/**
 * 어드민 전용 Supabase 클라이언트.
 *
 * 같은 Supabase 프로젝트(앱과 동일한 anon key)를 사용하지만 storageKey를 분리해
 * 같은 도메인에 v1 어드민(heart-way.life/dugeun)이 있어도 세션 충돌을 일으키지 않는다.
 *
 * - storageKey: 'shimjanggil-admin-auth'  (v1 어드민과 동일 키 → 기존 어드민 세션 호환)
 * - storage: 기본값 localStorage (브라우저 전용)
 * - 권한 통제는 RLS + profiles.role 기반. anon key로만 동작하며 service_role 노출 금지.
 */
export const adminSupabase = createClient(
  supabaseUrl ?? 'https://placeholder.supabase.co',
  supabaseAnonKey ?? 'placeholder-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'shimjanggil-admin-auth',
    },
  },
)

export function isAdminSupabaseConfigured(): boolean {
  return !!(supabaseUrl && supabaseAnonKey && !supabaseUrl.includes('placeholder'))
}
